<ds-form-field [ngClass]="[styleClass]">
    <label
        ds-label
        *ngIf="label"
        [for]="inputId">
        {{ label | translate }}
    </label>
    <ds-icon
        *ngIf="icon"
        [icon]="icon"></ds-icon>
    <input
        ds-input
        [id]="inputId"
        [type]="'text'"
        [size]="'md'"
        [readonly]="readOnly"
        [disabled]="disabled"
        [maxlength]="maxLength"
        [required]="true"
        [placeholder]="placeholder"
        [title]="displayValue"
        [(ngModel)]="displayValue"
        (ngModelChange)="valueChanged.emit($event)" />
</ds-form-field>
